// storybook-check-ignore
import { useEffect } from 'react';

import { CredentialResponse, promptGoogleOneTap } from '@opendoor/shared-fe/build/googleOneTap';

import { emailConversionEvent } from './eventTracking';
import { GOOGLE_CLIENT_ID } from './globals';
import { ReceptionTrackingCategory, useObservability } from './observability';

export const usePromptGoogleOneTap = (onSuccess: (response: CredentialResponse) => void) => {
  const { trackEvent, trackError } = useObservability();
  useEffect(() => {
    promptGoogleOneTap<ReceptionTrackingCategory>({
      analyticsName: 'reception',
      clientId: GOOGLE_CLIENT_ID,
      onSuccess: (response) => {
        emailConversionEvent({
          googleOnTap: response.credential,
        });
        onSuccess(response);
      },
      trackEvent,
      trackError,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
